<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-input :model="$schema.name" />
      </div>

      <div class="form-group col-12">
        <w-select :values="actions" :model="$schema.action" />
      </div>

      <div class="form-group col-12">
        <w-select :values="eventTypes" :model="$schema.type" />
      </div>

      <div class="form-group col-12">
        <w-monaco v-if="show" language="json" :model="$schema.actionData" />
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { ActionList } from '@/enums/action.enum';
import { EventTypeList } from '@/enums/eventType.enum';
import { formMixin } from '@/mixins/form';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/event.schema';

const emptyData = () => ({
  name: null,
  type: null,
  action: null,
  actionData: null
});

// @vuese
// Modal dodania zdarzenia
// @group Event
export default {
  mixins: [manageMixin('event', {}, emptyData), formMixin],
  schema,
  data: () => ({
    model: {},
    actions: ActionList,
    eventTypes: EventTypeList
  }),
  computed: {
    title() {
      return this.id ? 'Edycja zdarzenia' : 'Dodawanie zdarzenia';
    }
  }
};
</script>